import React from 'react';

import { styled } from '@linaria/react';
import { ITheme, useTheme } from 'src/theme-revamp';

const ButtonElement = styled.button<ButtonProps>`
  opacity: ${(props) => props.disabled ? 0.25 : 1};
  background-color: ${(props) => props.variant === 'default' || props.variant === 'input'
      ? props.bgColor ? props.bgColor : '#0A544F'
      : props.variant === 'light'
      ? props.theme?.colors.grey[1300]
      : props.theme?.colors.white};
  border: 1px solid
    ${(props) => props.variant === 'default' || props.variant === 'input'
        ? props.borderColor ? props.borderColor : '#0A544F'
        : props.variant === 'secondary'
        ? props.borderColor ? props.borderColor : '#0A544F'
        : props.variant === 'light'
        ? props.theme?.colors.grey[1300]
        : props.theme?.colors.grey[700]};
  border-radius: 100rem;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  color: ${(props) => props.textColor ? props.textColor : props.variant === 'secondary'
      ? '#0A544F'
      : props.variant === 'light'
      ? props.theme?.colors.grey[1200]
      : props.theme?.colors.white};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  display: ${(props) =>
    props.display === 'inline' ? 'inline-block' : 'block'};
  font-family: ${(props) => props.theme?.fontFamily + ''};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.1px;
  line-height: ${props => props.lineHeight ? props.lineHeight : '18px'};
  margin: ${(props) =>
    typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  outline: 0;
  padding: ${(props) =>
    typeof(props.padding) === 'string'
    ? props.padding
    : typeof(props.padding) === 'number'
    ? props.padding + 'px'
    : props.variant === 'input' ? '12px 30px' : '16px 24px'};
  width: ${(props) =>
    props.display === 'block' ? (props.width ? props.width : '100%') : 'auto'};
  height: ${(props) =>
    props.display === 'block' ? (props.height ? props.height : '100%') : 'auto'};
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  transition: background-color 0.35s, border-color 0.35s, color 0.35s;
  @media (hover: hover){
    &:hover {
      /* background-color: ${(props) =>
        props.disabled
          ? props.theme?.colors.grey[1500]
          : props.variant === 'secondary'
          ? props.hoverBgColor ? props.hoverBgColor : '#0A544F'
          : props.variant === 'light'
          ? props.theme?.colors.white
          : props.hoverBgColor ? props.hoverBgColor : '#0A544F'};
      border: 1px solid
        ${(props) =>
          props.disabled
            ? props.theme?.colors.grey[1500]
            : props.variant === 'light'
            ? props.theme?.colors.white
            : props.borderColor ? props.borderColor : '#0A544F'};
      color: ${(props) =>
        props.disabled
          ? props.theme?.colors.white || props.theme?.colors.grey[100]
          : props.variant === 'default'
          ? props.hoverTextColor ? props.hoverTextColor 
          : props.theme?.colors.white
          : props.variant === 'light'
          ? props.textColor ? props.textColor 
          : '#0A544F'
          : props.theme?.colors.white
          };
      box-shadow: ${(props) =>
        (props.boxShadowDisabled?false:true) &&  (props.variant === 'light' || props.variant === 'default') && !props.disabled ? '0px 1px 20px rgba(0, 0, 0, 0.1)' : 'none'};
      transition: background-color 0.35s, border-color 0.35s, color 0.35s; */

    }
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 295px;
  }
`;

export interface ButtonProps {
  variant?: 'default' | 'secondary' | 'input' | 'light';
  boxShadowDisabled?: boolean;
  display?: 'inline' | 'block';
  disabled?: boolean;
  width?: string;
  height?: string;
  lineHeight?: string;
  label?: string;
  theme?: ITheme;
  onClick?: () => void;
  // onHover?: () => void;
  margin: string | number;
  padding?: string | number;
  bgColor?: string;
  hoverBgColor?: string;
  borderColor?: string;
  textColor?: string;
  hoverTextColor?: string;
  className?:string;
}

const Button = ({
  variant,
  display,
  margin,
  padding,
  width,
  height,
  lineHeight,
  label,
  onClick,
  bgColor,
  hoverBgColor,
  borderColor,
  textColor,
  hoverTextColor,
  // onHover,
  ...props
}: ButtonProps) => {
  const theme: ITheme = useTheme();
  return (
    <ButtonElement
      margin={margin}
      padding={padding}
      variant={variant}
      display={display}
      theme={theme}
      onClick={onClick}
      // onHover={onHover}
      width={width}
      height={height}
      lineHeight={lineHeight}
      bgColor={bgColor}
      hoverBgColor={hoverBgColor}
      borderColor={borderColor}
      textColor={textColor}
      hoverTextColor={hoverTextColor}
      {...props}
    >
      {label}
    </ButtonElement>
  );
};

Button.defaultProps = {
  variant: 'default',
  display: 'block',
  margin: '0',
  boxShadowDisabled: false,
};

export default Button;
